<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll()"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listPhoneNumberSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('action_list', null,null, 0)"
              color="danger">
              <i class="fa fa-stop-circle mr-2" style="font-size: 1.1rem!important;"></i>
              Xóa lô sim
            </button>
            <button
              :disabled="actionData.model.listPhoneNumberSelectedId.length === 0"
              class="dropdown-item"
              @click="clickExtend(0)"
              color="danger">
              <i class="fa fa-cart-plus mr-2" style="font-size: 1.1rem!important;"></i>
              Gia hạn lô sim
            </button>
          </div>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect :options="phoneSimSelect.options" :data="phoneSimSelect.data"
                    ref="phoneSimSelect"></BaseSelect>
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput
          :options="phoneNumberInput.options"
          :data="phoneNumberInput.data"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="clickAdd()">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listPhoneNumberSelectedId"
                  :value="item.id"
                  :id="item.id"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{item}">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYY(item.createDate) }}
            </td>
          </template>
          <template #stockEntryDate="{item}">
            <td>
              <span class="badge badge-secondary">{{ $helper.formatDateDDMMYYYY(item.stockEntryDate) }}</span>
            </td>
          </template>
          <template #dayContract="{item}">
            <td>
              <span class="badge badge-primary">{{ $helper.formatDateDDMMYYYY(item.dayContract) }}</span>
            </td>
          </template>
          <template #provider="{item}">
            <td>
              <span class="badge badge-secondary">{{ item.provider }}</span>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
              <CCardBody style="margin-left: 30px">
                <h5>Danh sách Số điện thoại lô SIM: {{ item.description }}</h5>
                <CDataTable
                  class="custom-scroll"
                  :items="mainTablePhoneNumberDetail.items"
                  :fields="mainTablePhoneNumberDetail.options.fields"
                  :sorter="true"
                  :loading="loading.value"
                  :sorterValue="{ column: null, asc: 'true' }"
                  :clickableRows="true"
                  @row-clicked="rowClickTablePhoneNumberDetail"
                  :hover="false">
                  <template slot="thead-top">
                    <div class="group-checkbox" style="position: absolute; left:12px;top: 7px;z-index: 1">
                      <div class=" btn-group" style="height: 36px;">
                        <div class="group-checkbox">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                   v-model="actionData.model.selectedAllPhoneDetail"
                                   @change="changeSelectAllPhoneDetail()"/>
                            <label class="custom-control-label" for="selectedAll"></label>
                          </div>
                        </div>
                        <template v-if="actionData.model.listPhoneNumberDetailSelectedId.length > 0">
                        <span
                          class="dropdown-toggle dropdown-toggle-split"
                          data-toggle="dropdown"
                          aria-expanded="false"
                          aria-haspopup="true" style="position: absolute;left: 20px;"></span>
                          <div class="dropdown-menu">
                            <button
                              style="border-radius: unset!important;"
                              class="dropdown-item"
                              @click="setupSelectOneAction('action_list', null,null, 1)"
                              color="danger">
                              <i class="fa fa-stop-circle mr-2" style="font-size: 1.1rem!important;"></i>
                              Xóa SIM
                            </button>
                            <button
                              style="border-radius: unset!important;"
                              class="dropdown-item"
                              @click="clickExtend(2)"
                              color="danger">
                              <i class="fa fa-cart-plus mr-2" style="font-size: 1.1rem!important;"></i>
                              Gia hạn SIM
                            </button>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template #checkbox="{item}">
                    <td class="group-checkbox">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="actionData.model.listPhoneNumberDetailSelectedId"
                          :value="item.id"
                          :id="item.id"
                        />
                        <label class="custom-control-label" :for="item.id"></label>
                      </div>
                    </td>
                  </template>
                  <template #expireDateDevice="{item}">
                    <td>
                      <span>{{ $helper.formatDateDDMMYYYY(item.expireDateDevice) }}</span>
                    </td>
                  </template>
                  <template #expireDataDate="{item}">
                    <td>
                      <span>{{ $helper.formatDateDDMMYYYY(item.expireDataDate) }}</span>
                    </td>
                  </template>
                  <template #action="{item, index}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                          color="primary"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Gia hạn'"
                          @click="clickExtend(3, item)">
                          <i class="fa fa-cart-plus"></i>
                        </CButton>
                        <CButton
                          color="primary"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Xem lịch sử'"
                          @click="showHistory(item)">
                          <i class="fa fa-eye"></i>
                        </CButton>
                        <CButton
                          color="danger"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Xóa'"
                          @click="setupSelectOneAction('delete_one_detail', item.id, item.phoneNumber)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                  <template slot="no-items-view">
                    <span style="color: #969696">Danh sách trống!</span>
                  </template>
                  <template slot="loading">
                    <BaseFormLoading :loading="true"></BaseFormLoading>
                  </template>
                </CDataTable>
              </CCardBody>
            </CCollapse>
          </template>
          <template #action="{item, index}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="primary"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Gia hạn'"
                  @click="clickExtend(1, item)">
                  <i class="fa fa-cart-plus"></i>
                </CButton>
                <CButton
                  color="primary"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xem danh sách SĐT'"
                  @click="toggleDetails(item, index)">
                  <i class="fa fa-eye"></i>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.description)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>

        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal :title="'Thêm mới SIM'" :show.sync="isShowModal"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <label v-html="dataSave.stockEntryDate.options.label"></label>
          <DatePicker id="datepicker" v-model="dataSave.stockEntryDate.data.model" locale="vi"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }"
                      class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue"
                v-on="inputEvents"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="form-group">
          <label v-html="dataSave.dayContractDate.options.label"></label>
          <DatePicker id="datepicker" v-model="dataSave.dayContractDate.data.model" locale="vi"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY'}" :popover="{ visibility: 'click' }"
                      class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue"
                v-on="inputEvents"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSave.providerSelect.options" :data="dataSave.providerSelect.data"
                      ref="providerSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="form-group">
          <div class="form-input-wrapper">
            <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
            <div class="custom-file"
                 :class="dataSave.selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
              <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                     :accept="acceptFile" @change="selectFile($event)">
              <label class="custom-file-label" for="uploadFile">{{ fileName }}
                <i v-if="dataSave.selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                   style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
              </label>
            </div>
            <div class="valid-error"
                 v-show="!(dataSave.selectedFiles.data.validator ? dataSave.selectedFiles.data.validator.isValid : true)">
              {{ dataSave.selectedFiles.data.validator ? dataSave.selectedFiles.data.validator.errorMessage : "" }}
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataSave.descriptionInput.options" :data="dataSave.descriptionInput.data"
                        v-model="dataSave.descriptionInput.data.model"/>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()">
          <i class="fa fa-plus"></i>Thêm mới
        </button>
      </template>
      <BaseLoading :loading="loading.value"></BaseLoading>
    </CModal>

    <CModal :title="'Gia hạn ' + modelExtend.txtModal"
            :show.sync="modelExtend.isShow"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="modelExtend.extendInput.options"
            :data="modelExtend.extendInput.data"
            :listener="modelExtend.extendInput.listener"
          />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="modelExtend.isShow = false"><i class="fa fa-times"></i>
          Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitExtend()">
          <i class="fa fa-check"></i>
          Gia hạn
        </button>
      </template>
    </CModal>

    <CModal v-if="modelShowHistory.isShow" :title="'Lịch sử SĐT: ' + modelShowHistory.txtModal"
            :show.sync="modelShowHistory.isShow"
            :closeOnBackdrop="false" :size="'xl'">
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable
            :options="mainTableHistoryPhoneNumber.options"
            :slots="mainTableHistoryPhoneNumber.slots"
            :dataSource="mainTableHistoryPhoneNumber.dataSource"
            ref="mainTableHistoryPhoneNumber">
            <template #index="{index}">
              <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>
            <template #createDate="{item}">
              <td>{{ $helper.formatDate(item.createDate) }}</td>
            </template>
            <template #afterExtendDate="{item}">
              <td>{{ $helper.formatDate(item.afterExtendDate) }}</td>
            </template>
            <template #beforeExtendDate="{item}">
              <td>{{ $helper.formatDate(item.beforeExtendDate) }}</td>
            </template>
            <template #action="{item, index}">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton
                    color="danger"
                    variant="outline"
                    class="ml-1"
                    square
                    size="sm"
                    v-c-tooltip.hover="'Xóa'">
                    <CIcon name="cil-trash"/>
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="modelShowHistory.isShow = false"><i
          class="fa fa-times"></i>
          Đóng
        </button>
      </template>
    </CModal>

    <BaseFormLoading :value="loading.value"></BaseFormLoading>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import {DatePicker} from "v-calendar";
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"
import BaseTextArea from "@/views/base/BaseTextArea";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "PhoneSimManageList",
  components: {
    BaseFormLoading,
    BaseLoading,
    BaseTextArea,
    DatePicker,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/phone_sim_manage/deletePhoneSim",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "số lô SIM",
          that.actionData.model.textNotifi
        )
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
        }
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa lô SIM " + that.actionData.model.textNotifi + " thành công"});
        that.$refs.phoneSimSelect.loadData();
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_one_detail", {
      url: "/phone_sim_manage/deleteDetail",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "số điện thoại",
          that.actionData.model.textNotifi
        )
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
        }
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa số điện thoại " + that.actionData.model.textNotifi + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("action_list", {
      url: "/phone_sim_manage/actionList",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", that.actionData.model.type == 0 ? "các lô SIM" : "các SIM", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          type: that.actionData.model.type,
          ids: that.actionData.model.type == 0 ? that.actionData.model.listPhoneNumberSelectedId : that.actionData.model.listPhoneNumberDetailSelectedId,
        };
      },
      successCallback: function () {
        that.actionData.model.listDeviceSelectedId = [];
        that.showSuccessMsg({message: that.actionData.model.type == 0 ? "Xóa các lô SIM thành công" : "Xóa các SIM thành công"});
        if (that.actionData.model.type == 0) {
          that.$refs.phoneSimSelect.loadData();
        }
        that.loadDataMainTable();
      },
    });


    let that = this;
    return {
      loading: {value: false},
      isShowModal: false,
      collapseDuration: 0,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          selectedAllPhoneDetail: false,
          id: null,
          textNotifi: null,
          listPhoneNumberSelectedId: [],
          listPhoneNumberDetailSelectedId: [],
          type: null
        }
      },
      phoneSimSelect: {
        options: {
          filter: true,
          label: "Lô SIM",
          selectAllText: "Tất cả Lô SIM",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "phoneSimManageId",
          items: [],
          model: '',
          source: {
            url: '/phone_sim_manage/findAllPhoneSim',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.phoneSimSelect.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      phoneNumberInput: {
        options: {
          placeholder: "Số điện thoại",
          label: 'Số điện thoại'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTablePhoneNumberDetail: {
        options: {
          fields: [
            {key: "checkbox", label: "", sorter: false, filter: false},
            // {key: "id", label: "Ngày tạo"},
            {key: "phoneNumber", label: "Số điện thoại"},
            {key: "expireDataDate", label: "Ngày hết hạn (Ngày thực tế)"},
            {key: "expireDateDevice", label: "Ngày hết hạn (Ngày của thiết bị)"},
            {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: ["checkbox", "index", "id", "phoneNumber", "expireDateDevice", "expireDataDate"],
          sorter: true,
          // hover: false,
          columnFilter: false,
          clickableRows: true,
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
        },
        items: [],
      },

      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "stockEntryDate", label: "Ngày nhập SIM"},
            {key: "dayContract", label: "Ngày hợp đồng"},
            {key: "provider", label: "Nhà mạng"},
            {key: "description", label: "Mô tả"},
            {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: ["checkbox", "index", "createDate", "stockEntryDate", "dayContract", "provider", "action", "details"],
          pageSize: 20,
          sorter: true,
          // hover: false,
          columnFilter: false,
          clickableRows: true,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
        },
        dataSource: {
          url: "/phone_sim_manage/getPages",
          dataSubmit: function () {
            return {
              phoneSimManageId: that.phoneSimSelect.data.model || null,
              phoneNumber: that.phoneNumberInput.data.model || null,
            }
          },
          response: function (dataResponse) {
            that.actionData.model.listPhoneNumberSelectedId = [];
            return dataResponse.data;
          }
        }
      },

      mainTableHistoryPhoneNumber: {
        options: {
          fields: [
            {key: "createDate", label: "Thời gian thao tác"},
            {key: "createUsername", label: "Người thao tác"},
            {key: "beforeExtendDate", label: "Ngày trước khi thao tác"},
            {key: "afterExtendDate", label: "Ngày sau khi thao tác"},
            // {key: "phoneNumber", label: "Số điện thoại"},
            {key: "extendNumber", label: "Số tháng"},
            // {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: ["index", "createDate", "beforeExtendDate", "afterExtendDate", "action", "details"],
          pageSize: 10,
          sorter: true,
          columnFilter: false,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
        },
        dataSource: {
          url: "/phone_sim_manage/getPagesHistoryPhoneNumber",
          dataSubmit: function () {
            return {
              phoneNumber: that.modelShowHistory.phoneNumber,
            }
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },

      fileName: 'Chọn tệp Excel',
      acceptFile: ".xlsx, .xls",
      dataSave: {
        stockEntryDate: {
          options: {
            label: "Ngày nhập SIM (Ngày Cty nhận) <span class='required'>*</span>",
          },
          data: {
            name: "stockEntryDate",
            model: new Date(),
          }
        },
        dayContractDate: {
          options: {
            label: "Ngày hợp đồng <span class='required'>*</span>",
          },
          data: {
            name: "dayContractDate",
            model: new Date(),
          }
        },
        providerSelect: {
          options: {
            label: "Nhà mạng <span class='required'>*</span>",
            keyField: "value",
            valueField: "text"
          },
          data: {
            name: "providerInput",
            model: "VIETTEL",
            items: [
              {text: 'Viettel', value: 'VIETTEL'},
              {text: 'Vinaphone', value: 'VINAPHONE'}
            ]
          }
        },
        selectedFiles: {
          data: {
            loading: false,
            name: "file",
            model: {
              fileName: '',
              content: '',
              size: '',
              type: ''
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                this.isValid = that.validateFile();
                return this.isValid;
              }
            }
          }
        },
        descriptionInput: {
          options: {
            label: "Mô tả <span class='required'>*</span>",
            placeholder: "Mô tả (tối đa 500 kí tự)",
            type: "text",
            maxlength: 500,
            rows: 10
          },
          data: {
            name: "description",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.descriptionInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Nội dung không được để trống";
                } else if (value.length > 5000) {
                  this.isValid = false;
                  this.errorMessage = "Nội dung không quá 5000 kí tự";
                } else if (value.length < 4) {
                  this.isValid = false;
                  this.errorMessage = "Nội dung phải từ 4 kí tự";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
      },
      modelExtend: {
        type: null,
        isShow: false,
        txtModal: null,
        extendInput: {
          options: {
            placeholder: "Số tháng gia hạn",
            label: 'Số tháng gia hạn <span class=\'required\'>*</span>',
            // type: 'number',
            addInputClasses: "number-extend",
          },
          data: {
            name: "extend",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.modelExtend.extendInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Số tháng gia hạn không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          },
          listener: {
            keyup: function (event) {
              if (event.key === "Enter") {
                that.submitExtend();
              }
            }
          }
        },
      },
      modelShowHistory: {
        isShow: false,
        txtModal: "",
        phoneNumber: null
      }
    };
  },
  methods: {
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listPhoneNumberSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listPhoneNumberSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listPhoneNumberSelectedId = [];
      }
    },
    changeSelectAllPhoneDetail: function () {
      if (this.actionData.model.selectedAllPhoneDetail) {
        this.actionData.model.listPhoneNumberDetailSelectedId = [];
        this.mainTablePhoneNumberDetail.items.forEach(each => {
          this.actionData.model.listPhoneNumberDetailSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listPhoneNumberDetailSelectedId = [];
      }
    },
    toggleDetails(item, index) {
      this.mainTablePhoneNumberDetail.items = item.phoneDetails;
      this.$refs.mainTable.items.map((each, _index) => {
        if (index == _index) {
          each._toggled = !each._toggled;
        } else {
          each._toggled = false;
        }
      })
      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
      this.actionData.model.listPhoneNumberDetailSelectedId = [];
    },
    rowClickTable(value) {
      let targetClick = value.event.target;
      // if (value.column === 'volume' && ($(targetClick).is("button") || $(targetClick).is("span") || $(targetClick).is("i"))) {
      //   return;
      // } else
      if (value.column === 'details' || value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listPhoneNumberSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listPhoneNumberSelectedId.indexOf(value.item.id)
          if (index > -1) {
            this.actionData.model.listPhoneNumberSelectedId.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listPhoneNumberSelectedId.push(value.item.id);
        }
      }
    },
    rowClickTablePhoneNumberDetail(_item, _index, _column, _event) {
      let targetClick = _event.target;
      if (_column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (_item && _item.id) {
        if (this.actionData.model.listPhoneNumberDetailSelectedId.includes(_item.id)) {
          const index = this.actionData.model.listPhoneNumberDetailSelectedId.indexOf(_item.id)
          if (index > -1) {
            this.actionData.model.listPhoneNumberDetailSelectedId.splice(index, 1);
            _item._classes = 'inactive';
          }
        } else {
          _item._classes = 'active';
          this.actionData.model.listPhoneNumberDetailSelectedId.push(_item.id);
        }
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, id, textNotifi, type) {
      let actionData = this.actionData.model;
      actionData.id = id;
      actionData.textNotifi = textNotifi;
      actionData.type = type;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickAdd() {
      this.isShowModal = true;
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.dataSave.selectedFiles.data.loading = true;
        reader.readAsDataURL(file);

        reader.onload = function () {
          that.fileName = file.name;
          that.validateFile(file.type, file.size);
          that.dataSave.selectedFiles.data.model.size = file.size;
          that.dataSave.selectedFiles.data.model.fileName = file.name;
          that.dataSave.selectedFiles.data.model.type = file.type;
        }
        reader.onloadend = function () {
          that.dataSave.selectedFiles.data.loading = false;
        }
      } else {
        that.fileName = "Chọn tệp";
        that.dataSave.selectedFiles.data.model.size = "";
        that.dataSave.selectedFiles.data.model.fileName = "";
        that.dataSave.selectedFiles.data.model.type = "";
        that.validateFile();
      }
    },
    validateFile(type, size) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, size);
      } else {
        if (this.dataSave.selectedFiles.data.model.type && this.dataSave.selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.dataSave.selectedFiles.data.model.type, this.dataSave.selectedFiles.data.model.size);
        } else {
          if (this.dataSave.selectedFiles.data.model.fileName === '') {
            this.dataSave.selectedFiles.data.validator.isValid = false;
            this.dataSave.selectedFiles.data.validator.errorMessage = "Nội dung bản tin không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type, size) {
      let isValid = true;
      // if (size > FILE_MAX_SIZE && IS_CHECK_MAX_SIZE_UPLOAD) {
      //   this.dataSave.selectedFiles.data.validator.isValid = false;
      //   this.dataSave.selectedFiles.data.validator.errorMessage = "Tệp tin không được quá 150MB";
      //   isValid = false;
      // } else
      if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
        this.dataSave.selectedFiles.data.validator.isValid = true;
        this.dataSave.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.dataSave.selectedFiles.data.validator.isValid = false;
        this.dataSave.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
        isValid = false;
      }
      return isValid;
    },

    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.dataSave.descriptionInput.data.validator.valid();
      isValid &= this.dataSave.selectedFiles.data.validator.valid();
      if (!isValid) {
        return;
      }

      that.loading.value = true;
      let formData = new FormData();
      formData.append("description", that.dataSave.descriptionInput.data.model);
      formData.append("file", that.$refs.file.files[0]);
      formData.append("stockEntryDate", that.$helper.formatDateDDMMYYYY(that.dataSave.stockEntryDate.data.model));
      formData.append("dayContract", that.$helper.formatDateDDMMYYYY(that.dataSave.dayContractDate.data.model));
      formData.append("provider", that.dataSave.providerSelect.data.model);

      that.$helper.loadDataSource({
        url: "/phone_sim_manage/create",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: "Thêm mới lô SIM thành công"});
          }
          that.isShowModal = false;
          that.loading.value = false;
          that.$refs.phoneSimSelect.loadData();
          that.loadDataMainTable();
          that.clearDataSave();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    clearDataSave() {
      this.dataSave.dayContractDate.data.model = new Date();
      this.dataSave.stockEntryDate.data.model = new Date();
      this.dataSave.descriptionInput.data.model = '';
      this.fileName = 'Chọn tệp Excel';
      this.dataSave.providerSelect.data.model = "VIETTEL";
      this.dataSave.selectedFiles.data.model = {
        content: '',
        fileName: '',
        size: '',
        type: ''
      };
    },
    clickExtend: function (type, item) {
      this.modelExtend.isShow = true;
      this.modelExtend.type = type;
      if (type == 0) {
        this.modelExtend.txtModal = "Các Lô SIM";
      } else if (type == 1) {
        this.modelExtend.txtModal = "Lô SIM";
        this.actionData.model.id = item.id;
      } else if (type == 2) {
        this.modelExtend.txtModal = "Các SIM";
      } else if (type == 3) {
        this.modelExtend.txtModal = "SIM";
        this.actionData.model.id = item.id;
      }
      let that = this;
      setTimeout(() => {
        that.$helper.setupInputNumber('number-extend');
        that.$el.querySelector(".number-extend").focus();
      }, 100)
    },
    submitExtend() {
      let that = this;
      let isValid = true;
      isValid &= this.modelExtend.extendInput.data.validator.valid();
      if (!isValid) {
        return;
      }

      that.loading.value = true;
      that.$helper.loadDataSource({
        url: "/phone_sim_manage/extend",
        dataSubmit: function () {
          return {
            type: that.modelExtend.type,
            numberExtend: that.modelExtend.extendInput.data.model,
            id: that.actionData.model.id,
            ids: that.modelExtend.type == 0 ? that.actionData.model.listPhoneNumberSelectedId : that.actionData.model.listPhoneNumberDetailSelectedId,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: "Gia hạn thành công"});
          }
          that.loadDataMainTable();
          that.loading.value = false;
          that.modelExtend.isShow = false;
          that.modelExtend.extendInput.data.model = "";
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    showHistory(item) {
      this.modelShowHistory.isShow = true;
      this.modelShowHistory.txtModal = item.phoneNumber;
      this.modelShowHistory.phoneNumber = item.phoneNumber;
      console.log(item)
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listPhoneNumberSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    "actionData.model.listPhoneNumberDetailSelectedId": function (newValue) {
      let that = this;
      if (that.mainTablePhoneNumberDetail.items.length > 0 && newValue.length === that.mainTablePhoneNumberDetail.items.length) {
        that.actionData.model.selectedAllPhoneDetail = true;
        that.mainTablePhoneNumberDetail.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAllPhoneDetail = false;
        if (newValue.length == 0) {
          that.mainTablePhoneNumberDetail.items.map(each => each._classes = 'inactive');
        }
      }
    },
  },
  computed: {}
};
</script>
<style scoped>

</style>
